export var ivrsRelativePath = '/ivrs';
export var createIvrsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + ivrsRelativePath;
    var ivrUrl = function (id) { return apiUrl + "/" + id; };
    return {
        getFlows: function () {
            return http.get(apiUrl);
        },
        addFlow: function (addIvrFlowDto) {
            return http.post("" + apiUrl, addIvrFlowDto);
        },
        updateFlow: function (updateIvrFlowDto) {
            return http.put("" + ivrUrl(updateIvrFlowDto.id), updateIvrFlowDto.data);
        },
        deleteFlow: function (ivrDto) {
            return http.delete("" + ivrUrl(ivrDto.id));
        },
    };
};
//# sourceMappingURL=index.js.map